import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Alert,
  Button,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { customerAuthAPI } from '../utils/api';

function VerifyMagicLink({ onLogin }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [error, setError] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      verifyToken(token);
    } else {
      setStatus('error');
      setError('Invalid link - no token provided');
    }
  }, [searchParams]);

  const verifyToken = async (token) => {
    try {
      const response = await customerAuthAPI.verifyMagicLink(token);
      localStorage.setItem('customerToken', response.data.token);
      localStorage.setItem('customer', JSON.stringify(response.data.customer));
      if (onLogin) onLogin(response.data.customer);
      setStatus('success');

      // Redirect to portal after short delay
      setTimeout(() => {
        navigate('/portal');
      }, 1500);
    } catch (err) {
      setStatus('error');
      setError(err.response?.data?.error || 'Failed to verify link');
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #8B2635 0%, #A84454 50%, #D4A574 100%)',
        p: 2,
      }}
    >
      <Card sx={{ maxWidth: 400, width: '100%', textAlign: 'center' }}>
        <CardContent sx={{ p: 4 }}>
          {status === 'verifying' && (
            <>
              <CircularProgress size={60} sx={{ mb: 3 }} />
              <Typography variant="h6" gutterBottom>
                Verifying your login...
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Please wait a moment
              </Typography>
            </>
          )}

          {status === 'success' && (
            <>
              <CheckCircleIcon sx={{ fontSize: 60, color: 'success.main', mb: 2 }} />
              <Typography variant="h6" gutterBottom color="success.main">
                Successfully signed in!
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Redirecting to your portal...
              </Typography>
            </>
          )}

          {status === 'error' && (
            <>
              <ErrorIcon sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
              <Typography variant="h6" gutterBottom color="error.main">
                Sign in failed
              </Typography>
              <Alert severity="error" sx={{ mb: 3, textAlign: 'left' }}>
                {error}
              </Alert>
              <Button
                variant="contained"
                onClick={() => navigate('/portal/login')}
              >
                Back to Login
              </Button>
            </>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}

export default VerifyMagicLink;
